import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nested-form"
export default class extends Controller {
  static targets = [ 'template', 'item' ]
  static values = {
    wrapperSelector: String
  }

  add() {
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.element.querySelector(this.wrapperSelectorValue).insertAdjacentHTML('beforeend', content)
  }

  remove(event) {
    const item = event.target.closest("[data-nested-form-target='item']");
    const destroyField = item.querySelector("input[name*='_destroy']");
    if (destroyField) {
      destroyField.value = 1;
      item.style.display = 'none';
    } else {
      item.remove();
    }
  }
}
